import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { trackClick } from "../lib/track";

const isAffiliate = (href = "") => href.includes("umtugxsg.com");
const isExternal = (href = "") => /^https?:\/\//.test(href);

const MdLink = ({ href = "", children }) => {
  if (isAffiliate(href)) {
    const isNord = href.includes("trvid=56096");
    return (
      <a
        href={href}
        target="_blank"
        rel="nofollow sponsored noopener"
        data-testid="md-affiliate-cta"
        onClick={() => trackClick(href, "article-content-cta")}
        className={`group my-2 mr-3 inline-flex items-center gap-2 bg-[#4687FF] px-6 py-3 font-display text-sm font-bold tracking-tight text-white no-underline transition-[background-color,box-shadow,transform] duration-200 hover:bg-[#2563eb] ${
          isNord
            ? "shadow-[0_8px_28px_rgba(70,135,255,0.45)] ring-1 ring-[#7EAAFF]/50 hover:-translate-y-0.5 hover:shadow-[0_14px_40px_rgba(70,135,255,0.65)]"
            : ""
        }`}
      >
        {children}
        <ArrowUpRight size={16} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </a>
    );
  }
  if (isExternal(href)) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className="font-semibold text-[#4687FF] underline underline-offset-4">
        {children}
      </a>
    );
  }
  return (
    <Link to={href} className="font-semibold text-[#4687FF] underline underline-offset-4">
      {children}
    </Link>
  );
};

export const Markdown = ({ content }) => (
  <div className="article-body">
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: MdLink,
        h1: ({ children }) => (
          <h2 className="mb-5 mt-10 font-display text-2xl font-extrabold tracking-tight text-[#0F172A] sm:text-3xl">{children}</h2>
        ),
        h2: ({ children }) => (
          <h2 className="mb-5 mt-10 font-display text-2xl font-extrabold tracking-tight text-[#0F172A] sm:text-3xl">{children}</h2>
        ),
        h3: ({ children }) => (
          <h3 className="mb-4 mt-8 font-display text-xl font-extrabold tracking-tight text-[#0F172A]">{children}</h3>
        ),
        strong: ({ children }) => <strong className="font-bold text-[#0F172A]">{children}</strong>,
        blockquote: ({ children }) => (
          <blockquote className="my-6 border-l-4 border-[#4687FF] bg-[#4687FF]/[0.05] p-6 [&>p]:mb-0">{children}</blockquote>
        ),
        table: ({ children }) => (
          <div className="my-6 overflow-x-auto">
            <table className="w-full border-collapse text-left text-sm [&_td]:border-b [&_td]:border-slate-100 [&_td]:px-3 [&_td]:py-2 [&_th]:border-b-2 [&_th]:border-slate-200 [&_th]:px-3 [&_th]:py-2 [&_th]:font-display [&_th]:font-bold">
              {children}
            </table>
          </div>
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  </div>
);
